import "./Es3Footer.css";

const API_BASE = process.env.NODE_ENV === "production"
  ? window.location.origin
  : (process.env.REACT_APP_API_URL || "http://localhost:5000");

function trackClick(key) {
  const today = new Date().toISOString().slice(0, 10);
  const lsKey = `es_click_${key}`;
  if (localStorage.getItem(lsKey) === today) return;
  fetch(`${API_BASE}/api/stats/track`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key }),
  })
    .then(() => localStorage.setItem(lsKey, today))
    .catch(() => {});
}

function Es3Footer() {
  return (
    <footer className="es3-footer">
      <div className="es3-footer-logo">
        <img src="/image/exyst-space-logo.svg" alt="exyst space"
          onError={(e) => { e.target.style.display = "none"; }}
        />
      </div>
      <div className="es3-footer-cols">
        <div className="es3-footer-col">
          <h4 className="es3-footer-col-head">Visit</h4>
          DD Block, DHA Phase 4<br />Lahore
        </div>
        <div className="es3-footer-col">
          <h4 className="es3-footer-col-head">Follow Us</h4>
          <a href="https://www.instagram.com/exystspace" target="_blank" rel="noopener noreferrer" onClick={() => trackClick("ig_click")}>Instagram</a>
          <a href="https://www.tiktok.com/@exystspace" target="_blank" rel="noopener noreferrer" onClick={() => trackClick("tt_click")}>TikTok</a>
        </div>
        <div className="es3-footer-col">
          <h4 className="es3-footer-col-head">Say hello</h4>
          <a href="mailto:hello@exystspace.com">hello@exystspace.com</a>
        </div>
      </div>
      <div className="es3-footer-base">
        <span>© 2026 Exyst</span>
        <span>your story, your canvas, your stage</span>
      </div>
    </footer>
  );
}

export default Es3Footer;
